export default __webpack_public_path__ + "static/media/masterclass_rencontres_musicales.2e618925.pdf";